import Script from 'next/script';
import useMatchMedia from '@/hooks/useMatchMedia';
import PageHead from '@/components/common/PageHead';

import Container from '@/components/common/Container';
import Section from '@/components/common/Section';
import Heading from '@/components/common/Heading';
import ClientOnly from '@/components/common/ClientOnly';
import Box from '@/components/common/Box/Box';

import ServicesIntroduction from '@/components/Pages/Services/ServicesIntroduction';
import ServicesLayout from '@/components/Pages/Services/ServicesLayout';
import ServicesBlock from '@/components/Pages/Services/ServicesBlock';
import Info from '@/components/Pages/Index/Info';
import FAQs from '@/components/Pages/Index/FAQs';
import InnerHero from '@/components/InnerHero';
import BackgroundHero from '@/components/common/Background/BackgroundHero';

import webdesignBlock from '@/db/services/websupport/websupportBlock.json';
import faqs from '@/db/services/websupport/websupportFaq.json';
import info from '@/db/services/websupport/websupportInfo.json';
import innerHero from '@/db/services/websupport/websupportHero.json';
import introduction from '@/db/services/websupport/websupportIntroduction.json';

import websupportMeta from '@/db/services/websupport/websupportMeta.json';
import ss_websupport from '@/db/seoscript/ss_websupport.json';

const WebSupport = () => {
  const { isMobile } = useMatchMedia();
  return (
    <>
      <PageHead {...websupportMeta} />

      <Box className=" relative">
        <Container>
          <Section className="pt-0 pb-0 lg:pb-4">
            <InnerHero innerHero={innerHero} />
          </Section>
        </Container>
        <BackgroundHero />
      </Box>

      <Container>
        <Section className=" lg:mx-[150px]">
          <Heading headingLevel="h2" className="text-center mb-5 md:mb-16  ">
            Support Services
          </Heading>
          <ServicesIntroduction introduction={introduction} />
        </Section>
      </Container>

      <Container>
        <Section>
          <ServicesBlock webdesignBlock={webdesignBlock} />
        </Section>
      </Container>

      <Container>
        <Section className="px-0 md:px-[50px]">
          <Heading headingLevel="h2" className=" text-center mb-5 md:mb-16">
            Ensuring Smooth Operation and Maintenance of Your Website
          </Heading>
          <Info info={info} />
        </Section>
      </Container>

      <Container>
        <Section>
          <Heading headingLevel="h2" className="text-center mb-5 md:mb-16">
            <ClientOnly>
              {isMobile ? 'FAQs' : 'Frequently Asked Questions'}
            </ClientOnly>
          </Heading>
          <FAQs faqs={faqs} />
        </Section>
      </Container>

      <Script
        id="ss_websupport"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(ss_websupport) }}
      />
    </>
  );
};
WebSupport.PageLayout = ServicesLayout;

export default WebSupport;
